import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Autocomplete, Box, Grid, TextField, useTheme, Typography } from '@mui/material'
import { addMinutes, format } from 'date-fns'

import { useGET_meetingsQuery } from 'redux/api/meetingsApi'
import { useGET_groupCourseSessionsQuery } from 'redux/api/sessionsApi'

import BoxTitle from 'components/atoms/BoxTitle'

import { ELEMENT_RADIUS_MID, PRIMARY_YELLOW } from 'utils/customizedTheme'
import { EventNote } from '@mui/icons-material'

import agendaIcon from 'assets/images/icons/agenda-icon.png'
import { useNavigate } from 'react-router-dom'


const Agenda: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const theme = useTheme()
  const [filter, setFilter] = useState<string | null>('')
  const [inputValue, setInputValue] = useState('')
  
  const date = new Date()
  const today = format(new Date(), 'yyyy-MM-dd')

  const { data: sessions } = useGET_groupCourseSessionsQuery({
    page: 1,
    ordering: 'start_datetimie',
    start_date_from: today,
    start_date_to: today,
  })
  const { data: meetings } = useGET_meetingsQuery({ page: 1, start_date_from: today, start_date_to: today })
  const options = [
    { label: 'Meeting', id: 'meeting' },
    { label: 'Group course session', id: 'session' },
  ]

  const list = []

  meetings?.results.forEach((meeting) => {
    list.push({
      groupId: 'meeting',
      title: meeting.purpose,
      url: `/meetings/view/${meeting.id}`,
      start: format(new Date(meeting.start_datetime), 'p'),
      end: meeting.duration_minutes
        ? format(addMinutes(new Date(meeting.start_datetime), meeting.duration_minutes), 'p')
        : null,
    })
  })

  return (
    <Box className="transparent-background">
      <Grid container spacing={2}>
        <Grid item xs={12} xl={12}>
          <BoxTitle title={t('common.agenda')} icon={<img src={agendaIcon} style={{ height: '22px' }} />} />
          <Typography
            sx={{
              fontFamily: 'NewsReader',
              fontWeight: '400',
              fontSize: '1rem',
              marginTop: 2,
              marginBottom: 2,
            }}
          >
            {t('dashboard.today', { date })}
          </Typography>
        </Grid>

        { /*
        <Grid item xs={12} xl={6}>
          <Grid container sx={{ alignItems: 'center', justifyContent: 'flex-start' }}>
            <Grid item>
              <Autocomplete
                disablePortal
                placeholder="Event type"
                options={options}
                sx={{ width: '100%' }}
                value={filter}
                onChange={(e, value: { label: string; id: string } | null) => {
                  setFilter(value ? value?.id : '')
                }}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                  setInputValue(newInputValue)
                }}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      background: theme.palette.background.default,
                      zIndex: 1,
                      position: 'relative',
                      '& .MuiInputBase-root': { borderRadius: ELEMENT_RADIUS_MID, padding: '0.75rem !important' },
                      '& label': { top: '2px !important' },
                      '& input': { padding: '0 !important', textTransform: 'capitalize' },
                    }}
                    {...params}
                  />
                )}
              />
            </Grid>
          </Grid> 
        </Grid>*/ }

        <Grid item xs={12}>
          {
            list?.filter(item => filter ? item.groupId === filter : true).map((item, index) => 
              <Box 
                onClick={() => navigate(item.url)} 
                key={index}
                my={1} 
                className="transparent-background"
                sx={{ cursor: 'pointer', paddingLeft: '10px', borderLeft: `6px solid ${PRIMARY_YELLOW}` }}>
                <span style={{ fontSize: '0.8rem', marginRight: '10px' }}>{`${item.start} - ${item.end}:`}</span> 
                <span>{`${item.title}`}</span> 
              </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  )
}

export default Agenda
